import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ResetAttendenceService } from '../../../Model/ResetAttendence/reset-attendence.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-attendence-reset',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './attendence-reset.component.html',
  styleUrl: './attendence-reset.component.scss'
})
export class AttendenceResetComponent {
  dtTrigger: Subject<any> = new Subject<any>();
  public User: any = null;
  EmployeeCode: string = '';
  EmployeeType: string = 'Front';
  EmployeeAttendenceData: any[] = [];
  isDisabled: boolean = false;
  DailyAttendanceInOutID: number = 0;
  Deleted: boolean = false;
  CheckOut: boolean = false;
  OutTime: string = '';
  EmployeeMasterID: number = 0;
  dtoptions: DataTables.Settings = {};
  constructor(private dailyattendence: ResetAttendenceService,
    private modalService: NgbModal,
    private sessionService: SessionService,
    private toast: ToastService,
    private combo: ComboService,
    protected common: CommonService,
    private tooltip : TooltipService
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {}
  
  onSelectionChange(type: string, event: any) {
    if (type == 'EmployeeType') {
      this.EmployeeType = event.target.value;
      this.EmployeeAttendenceData = [];
      this.OutTime = '';
    }
  }
  Search() {
    if (this.EmployeeCode == '') {
      this.toast.show({ message: 'Please Enter Employee Code!', type: toastTypeEnum.warning });
      return;
    }
    else {
      this.ComboLoad('EmpLoadForAttendance', this.EmployeeCode);
    }
  }
  ComboLoad(Combotype: String, id = '') {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype,
      'EmpType': this.EmployeeType,
      'EmpCode': id,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'EmpLoadForAttendance') {
          this.EmployeeAttendenceData = response.ComboLoad;
          if (this.EmployeeAttendenceData.length === 0) {
            this.toast.show({ message: 'Data not found or Employee Code is Invalid!', type: toastTypeEnum.warning });
            this.isDisabled = false;
            return
          }
          this.OutTime = this.EmployeeAttendenceData[0].OutTime;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  async delete() {
    await this.common.getPageRights();
    if (this.EmployeeAttendenceData.length === 0) {
      this.toast.show({ message: 'No Data Available!', type: toastTypeEnum.warning });
      return
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to delete?'
    modalRef.result.then((result: any) => {
      if(this.common.PageRight.IsDelete){
        if (result) {
          this.Deleted = true;
          this.CheckOut = false;
          this.update();
        }
      }else{
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
    });

  }
  async Checkout() {
    await this.common.getPageRights();
    if (this.EmployeeAttendenceData.length === 0) {
      this.toast.show({ message: 'No Data Available!', type: toastTypeEnum.warning });
      return
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to Check Out?'
    modalRef.result.then((result: any) => {
      if(this.common.PageRight.IsEdit){
        if (result) {
          this.Deleted = false;
          this.CheckOut = true;
          this.update();
        }
      }else{
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
    });
  }
  update() {
    this.isDisabled = true;
    this.DailyAttendanceInOutID = this.EmployeeAttendenceData[0].DailyAttendanceInOutID;
    this.EmployeeMasterID = this.EmployeeAttendenceData[0].EmpMasterID;
    const dailyAttendenceUpdate = {
      EmpMasterId: 0,
      EmpType: this.EmployeeType,
      EmpCode: this.EmployeeCode,
      DailyAttendanceInOutID: this.DailyAttendanceInOutID,
      Deleted: this.Deleted,
      CheckOut: this.CheckOut
    };
    this.dailyattendence.Ess_DailyAttendenceUpdate(dailyAttendenceUpdate).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
          if (this.CheckOut == true) {
            this.ComboLoad('EmpLoadForAttendance', this.EmployeeCode);
          }
          else if(this.Deleted == true){
            this.EmployeeAttendenceData = [];
          }
          this.isDisabled = false;
          this.OutTime = ''
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
          this.isDisabled = false;
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }
  onKeyPress(event: any) {
    this.EmployeeAttendenceData = [];
    this.OutTime = ''
  }
}
